import { Vue } from 'vue-property-decorator'

export const invoiceStatus = () => {
  return {
    REGULAR: { key: 50130001, label: Vue.prototype.$gettext('INVOICES_STATUS.50130001') },
    JUDICIAL_COLLECTION: { key: 50130002, label: Vue.prototype.$gettext('INVOICES_STATUS.50130002') },
    ADVISORY_PORTFOLIO: { key: 50130003, label: Vue.prototype.$gettext('INVOICES_STATUS.50130003') },
    EXEMPT: { key: 50130004, label: Vue.prototype.$gettext('INVOICES_STATUS.50130004') },
    PAID: { key: 50130005, label: Vue.prototype.$gettext('INVOICES_STATUS.50130005') },
    DUPLICITY: { key: 50130006, label: Vue.prototype.$gettext('INVOICES_STATUS.50130006') },
    NEGOTIATION: { key: 50130007, label: Vue.prototype.$gettext('INVOICES_STATUS.50130007') }
  }
}
